import { useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";

const InfoSection = ({ title, children, initialShowState=false }) => {
  const [showInfo, setShowInfo] = useState(initialShowState);
  return (
    <div className="info-section">
      <div
        className="d-flex align-items-center justify-content-between"
        style={{ cursor: "pointer" }}
        onClick={() => { setShowInfo(!showInfo); }}
      >
        <div className="d-flex align-items-center">
          <FaInfoCircle
            style={{
              color: "#1565c0",
              fontSize: "22px",
              marginRight: "8px"
            }}
          />
          <b>{title}</b>
        </div>

        <IoIosArrowDown
          fontSize={22}
          style={{
            transition: "transform 0.4s ease",
            transform: showInfo ? "rotate(-180deg)" : "rotate(0deg)",
            color: "#1565c0",
          }}
        />
      </div>

      {showInfo && children && (
        <>
          <hr style={{ margin: "8px 0", borderColor: "#90caf9" }} />
          {children}
        </>
      )}
    </div>
  );
}

export default InfoSection;